module.exports = __webpack_public_path__ + "static/media/icon-badge-white.a596ffb6.svg";